/**
 * @file: 对选中的层板进行编组
 * @author: xiaolong.huang@dmall.com
 */

import * as UIToolkit from '../../UIToolkit/index';
import * as Toolkit from '../../toolkit/index';
import Select from '../select/index';
import CodiSystem from '../../codiSystem/index';
import { __getLinks__, __replaceAll__ } from './db';
import { validate, updateLayerGroupStausAsync, updateTargetLayerGroupStatus } from './groupStatus';
import { createLink, layerLink } from './link';

// 编组选中的层板
function groupAllSelect(): void {
    let allSelected: Array<CubeId> = Select.getAll();
    let checkResult: ValidateResult = validate(allSelected);

    if (checkResult.code !== 0) {
        UIToolkit.tips(checkResult.msg);
        return;
    }
    let sortIds: CubeId[] = CodiSystem.sortByLeft(allSelected);
    let link: LinkedListInstance = createLink(sortIds);
    let oldLinks: LinkedListInstance[] = __getLinks__();

    Toolkit.linkGroupAdd(oldLinks, link);
    __replaceAll__(oldLinks);

    let layersLink: LinkedListInstance|null = layerLink(sortIds[0]);

    if (layersLink) {
        updateTargetLayerGroupStatus(layersLink);
    }
}

export {
    groupAllSelect
};
